const getters = {
    token: state => state.user.token,
    user: state => state.user.userInfo,
    roles: state => state.user.roles,
    menus: state => state.user.menus,
}
export default getters
